import { ReactNode } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

/**
 * This utility function checks if a given React component has any renderable content.
 * @param Component Component to check for content
 * @returns boolean indicating if the component has content
 */
export const hasContentInComponent = (Component: ReactNode) => {
  return Boolean(Component && renderToStaticMarkup(Component).trim())
}
